export { StreamingText } from './StreamingText';
export type { StreamingTextProps } from './StreamingText';
